import { GameStatus } from '@adgf/shared';
import type { GameManifest } from '@adgf/shared';

/**
 * Game Manifest for "One Tap Clicker".
 *
 * Mechanically distinct from the fixed-position 30-second-reaction game:
 * targets drift across the screen and a combo multiplier rewards
 * consecutive hits.
 */
const manifest: GameManifest = {
  id: '44444444-4444-4444-4444-444444444444',
  slug: 'one-tap-clicker',
  title: 'One Tap Clicker',
  description:
    'Tap the moving targets to build a combo multiplier. Missing resets it. Speed ramps up over 30 seconds.',
  version: '0.1.0',
  template_id: null,
  runtime: 'phaser',
  status: GameStatus.DRAFT,
  difficulty: 'easy',
  duration: 30,
  features: ['moving-target', 'combo', 'timer', 'speed-ramp', 'retry', 'touch-support'],
  entrypoint: '@adgf/game-one-tap-clicker',
  analytics_schema: {
    target_hit: 'number',
    combo: 'number',
    miss: 'number',
    time_left: 'number',
  },
};

export default manifest;
